import { getName } from "../../../../../ModelMixins/CatalogMemberMixin";
import Description from "../../../../Preview/Description";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const PrintDatasets = props => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.items.map((item, index) => /*#__PURE__*/_jsxs("details", {
      open: true,
      children: [/*#__PURE__*/_jsx("summary", {
        children: getName(item)
      }), /*#__PURE__*/_jsx(Description, {
        item: item,
        printView: true
      }, index)]
    }, index))
  });
};
export default PrintDatasets;